import React from "react";
import style from "./donation.module.css";
import { Col, Row } from "react-bootstrap";
export default function Faith({ onScrollToDonation }) {
  return (
    <>
      <div className={style.faithMaincontainer}>
        <div className="container">
          <Row>
            <Col
              lg={6}
              md={{ order: 1 }}
              className="d-flex justify-content-center"
            >
              <img className={style.familyimg} src="/faith.png" />
            </Col>
            <Col
              lg={6}
              md={{ order: 2 }}
              className=" d-flex justify-content-center align-items-center"
            >
              <div className={style.faithheading}>
                <h1>A Family of Faith, United for Life</h1>
                <p>
                  Together, we’re building a global movement of compassion — a
                  family of faith standing for life in every culture and
                  community. When you give to FundLife, your faith travels
                  farther than your feet ever could, reaching hearts and saving
                  lives across the globe.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className={style.mainbackground}>
        <div className="container">
          <div className={style.backgroundheading}>
            <h1>
              “Defend the weak and the fatherless; uphold the cause of the poor
              and the oppressed.”
            </h1>
            <p>— Psalm 82:3</p>
          </div>
        </div>
      </div>
      <hr className={style.hrline} />
      <div className={style.mainbackgroundlife}>
        <div className="container">
          <div className={style.backgroundlifeheading}>
            <h1>BE THE LIGHT.</h1>
            <h1>GIVE LIFE TODAY.</h1>
            <p>
              Every donation fuels hope and transforms lives across nations.
            </p>
            <button style={{ cursor: "pointer" }} onClick={onScrollToDonation}>
              Donate Now to the Global Fund Life
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
